import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icons from '../components/Icons';

export default function HelpCenterPage() {
  const navigate = useNavigate();
  return (
    <div className="custom-scroll page-enter" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'var(--bg)', zIndex: 9999, overflowY: 'auto' }}>
      
      <button onClick={() => navigate(-1)} style={{ position: 'absolute', top: 30, right: 30, width: 44, height: 44, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', color: 'var(--t2)', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 10 }}>
        <Icons.X sz={20} />
      </button>

      <div style={{ maxWidth: 800, margin: '0 auto', padding: '80px 20px', color: 'var(--t2)', lineHeight: 1.6 }}>
        
        <div style={{ textAlign: 'center', marginBottom: 50 }}>
          <div style={{ 
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', 
            width: 64, height: 64, borderRadius: 20, background: 'rgba(139,92,246,0.1)', 
            color: 'var(--ac3)', marginBottom: 20, border: '1px solid rgba(139,92,246,0.2)' 
          }}>
            <Icons.Help sz={32} />
          </div>
          <h1 style={{ fontSize: 36, color: 'var(--t1)', marginBottom: 12, fontWeight: 800 }}>How can we help?</h1>
          <p style={{ fontSize: 16, color: 'var(--t3)', maxWidth: 400, margin: '0 auto' }}>
            Browse guides, find answers to common questions, or get in touch with our team.
          </p>
        </div>

        {/* Quick Links Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 20, marginBottom: 40 }}>
          
          <div style={{ 
            background: 'linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01))', 
            padding: 24, borderRadius: 16, border: '1px solid rgba(255,255,255,0.05)', 
            transition: 'transform 0.2s, box-shadow 0.2s', cursor: 'pointer' 
          }} className="help-card">
            <div style={{ color: '#f472b6', marginBottom: 12 }}><Icons.Sparkle sz={24} /></div>
            <h3 style={{ color: 'var(--t1)', fontSize: 18, marginBottom: 8 }}>Getting Started</h3>
            <p style={{ fontSize: 13, color: 'var(--t3)' }}>Learn the basics of generating images, writing great prompts, and using models.</p>
          </div>

          <div style={{ 
            background: 'linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01))', 
            padding: 24, borderRadius: 16, border: '1px solid rgba(255,255,255,0.05)', 
            transition: 'transform 0.2s, box-shadow 0.2s', cursor: 'pointer' 
          }} className="help-card">
            <div style={{ color: '#06b6d4', marginBottom: 12 }}><Icons.Vid sz={24} /></div>
            <h3 style={{ color: 'var(--t1)', fontSize: 18, marginBottom: 8 }}>Video & Animation</h3>
            <p style={{ fontSize: 13, color: 'var(--t3)' }}>Master text-to-video, image-to-video, motion sync, and advanced rendering.</p>
          </div>

          <div style={{ 
            background: 'linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01))', 
            padding: 24, borderRadius: 16, border: '1px solid rgba(255,255,255,0.05)', 
            transition: 'transform 0.2s, box-shadow 0.2s', cursor: 'pointer' 
          }} className="help-card">
            <div style={{ color: '#fbbf24', marginBottom: 12 }}><Icons.Coin sz={24} /></div>
            <h3 style={{ color: 'var(--t1)', fontSize: 18, marginBottom: 8 }}>Billing & Credits</h3>
            <p style={{ fontSize: 13, color: 'var(--t3)' }}>Understand credit consumption, subscription tiers, and payment options.</p>
          </div>

          <div style={{ 
            background: 'linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01))', 
            padding: 24, borderRadius: 16, border: '1px solid rgba(255,255,255,0.05)', 
            transition: 'transform 0.2s, box-shadow 0.2s', cursor: 'pointer' 
          }} className="help-card">
            <div style={{ color: '#10b981', marginBottom: 12 }}><Icons.User sz={24} /></div>
            <h3 style={{ color: 'var(--t1)', fontSize: 18, marginBottom: 8 }}>Account & Storage</h3>
            <p style={{ fontSize: 13, color: 'var(--t3)' }}>Manage your profile, password, and learn about our data retention policies.</p>
          </div>

        </div>

        {/* FAQs Section */}
        <h2 style={{ fontSize: 24, color: 'var(--t1)', marginBottom: 20, paddingTop: 20, borderTop: '1px solid rgba(255,255,255,0.05)' }}>Frequently Asked Questions</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          
          <div style={{ background: 'rgba(0,0,0,0.15)', padding: '16px 20px', borderRadius: 12, border: '1px solid rgba(255,255,255,0.03)' }}>
            <h4 style={{ color: 'var(--t1)', fontSize: 15, marginBottom: 6 }}>How are credits consumed?</h4>
            <p style={{ fontSize: 13, color: 'var(--t3)', margin: 0 }}>Credits are deducted per generation task. Premium models (like Flux 2 Max or Veo 3.1) and higher resolutions (like 4K or Pro Mode) consume more credits than standard generations.</p>
          </div>

          <div style={{ background: 'rgba(0,0,0,0.15)', padding: '16px 20px', borderRadius: 12, border: '1px solid rgba(255,255,255,0.03)' }}>
            <h4 style={{ color: 'var(--t1)', fontSize: 15, marginBottom: 6 }}>Can I use generated images commercially?</h4>
            <p style={{ fontSize: 13, color: 'var(--t3)', margin: 0 }}>Yes! All generated content is entirely yours to use for commercial or personal purposes without attributing aiField, subject to our Acceptable Use Policy.</p>
          </div>

          <div style={{ background: 'rgba(0,0,0,0.15)', padding: '16px 20px', borderRadius: 12, border: '1px solid rgba(255,255,255,0.03)' }}>
            <h4 style={{ color: 'var(--t1)', fontSize: 15, marginBottom: 6 }}>Why did my generation fail?</h4>
            <p style={{ fontSize: 13, color: 'var(--t3)', margin: 0 }}>Generations can fail due to extremely complex prompts, temporary connectivity issues, or NSFW content filters. If a technical error occurs during generation, credits are typically refunded automatically.</p>
          </div>

        </div>

        {/* Contact Support */}
        <div style={{ 
          marginTop: 60, padding: 30, borderRadius: 20, textAlign: 'center',
          background: 'linear-gradient(135deg, rgba(139,92,246,0.1), rgba(6,182,212,0.1))',
          border: '1px solid rgba(255,255,255,0.05)'
        }}>
          <h3 style={{ fontSize: 20, color: 'var(--t1)', marginBottom: 8 }}>Still need help?</h3>
          <p style={{ fontSize: 14, color: 'var(--t3)', marginBottom: 20 }}>Our support team is always ready to assist you with any technical or billing issues.</p>
          <a href="mailto:support@aifield.art" style={{ 
            display: 'inline-block', padding: '10px 24px', background: 'var(--w)', color: '#000', 
            borderRadius: 99, fontSize: 13, fontWeight: 700, textDecoration: 'none' 
          }}>
            Contact Support
          </a>
        </div>

      </div>
      
      <style>{`
        .help-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 24px rgba(0,0,0,0.3);
          border-color: rgba(255,255,255,0.1) !important;
        }
      `}</style>
    </div>
  );
}
